namespace GeniuzPOS.Common {
    export interface ImportForm {
        Date: Serenity.DateEditor;
        FileName: Serenity.ImageUploadEditor;
    }

    export class ImportForm extends Serenity.PrefixedContext {
        static formKey = 'Common.ImportForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ImportForm.init)  {
                ImportForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.ImageUploadEditor;

                Q.initFormType(ImportForm, [
                    'Date', w0,
                    'FileName', w1
                ]);
            }
        }
    }
}
